import { Splide } from "@splidejs/splide";
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', function () {
    var sliderBannerElement = document.querySelector('.abi-howdowedo');
    if (sliderBannerElement) {
        var sliderBanner = new Splide(sliderBannerElement, {
            type: 'slide',
            perPage: 1,
            pagination: true,
            mediaQuery: 'min',
        });
        sliderBanner.mount();
    }
});
